import React from 'react';
import { Flex } from '@chakra-ui/react';

import { BasicHeaderLayout } from '@olo-web/components/atoms/BasicHeaderLayout';
import { BasicHeaderLogoOrName } from '@olo-web/components/atoms/BasicHeaderLogoOrName';
import { CustomerOrLogin } from '@olo-web/components/molecules/CustomerOrLogin';
import { DisruptionIconButton } from '@olo-web/components/molecules/DisruptionIconButton/DisruptionIconButton';

export const AccountNavBar = () => {
  return (
    <BasicHeaderLayout>
      <BasicHeaderLogoOrName />
      <Flex align="center" zIndex="2">
        <DisruptionIconButton display={{ base: 'none', md: 'inline' }} mx="10px" />
        <CustomerOrLogin />
      </Flex>
    </BasicHeaderLayout>
  );
};
